<div
  class="tab-bar"
  [class.fullWidth]="fullWidth()"
  [class.opaque]="opaque()"
  [class.icon-bar]="icon()"
  [class.disabled]="disabled()"
>
  <ng-content></ng-content>
</div>
